import { render } from "./VLoader.vue?vue&type=template&id=3835e95f"
import script from "./VLoader.vue?vue&type=script&lang=js"
export * from "./VLoader.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__